import { render, staticRenderFns } from "./VerificationAttendance.vue?vue&type=template&id=31eea567&"
import script from "./VerificationAttendance.vue?vue&type=script&lang=js&"
export * from "./VerificationAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports